import React, { useState } from "react";
import { DefaultOutboundLink } from "./../../Miscellaneous/DefaultLink.component";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const groupByYear = (awards) => {
  let result = {};
  awards.forEach((elem) => {
    if (!!result[elem.year]) {
      result[elem.year].push(elem);
    } else {
      result[elem.year] = [elem];
    }
  });
  return result;
};

const AwardBox = (props) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="mb-3"
      style={{
        boxShadow: hovered ? "1px 2px 4px #CABBBB" : "",
        borderRadius: "5px",
      }}
    >
      <DefaultOutboundLink to={props.link || ""}>
        <div
          className="w-100 d-flex border border-black-50"
          style={{
            minHeight: "60px",
            borderRadius: "5px",
          }}
        >
          <div
            className=""
            style={{
              width: "1%",
              backgroundColor: props.bgColor || "rgba(255, 140, 0, 0.8)",
              borderTopLeftRadius: "5px",
              borderBottomLeftRadius: "5px",
            }}
          />
          <div
            className="font-open-sans p-4 d-flex align-items-center justify-content-start fw-b text-muted"
            style={{
              width: "100%",
              transition: "0.2s linear",
              transform: hovered ? "translateX(20px)" : "",
              textTransform: "uppercase",
              letterSpacing: "1.25px",
              borderTopRightRadius: "5px",
              borderBottomRightRadius: "5px",
            }}
          >
            {props.title}
          </div>
        </div>
      </DefaultOutboundLink>
    </div>
  );
};

const AwardsList = ({ awards, bgColor }) => {
  const grouped = groupByYear(awards);

  return (
    <div>
      {[...Object.keys(grouped)]
        .sort()
        .reverse()
        .map((elem, idx) => (
          <AwardGroup
            bgColor={bgColor}
            key={elem}
            year={elem}
            contents={grouped[elem]}
          />
        ))}
    </div>
  );
};

const AwardGroup = (props) => {
  return (
    <div>
      <Row>
        <Col
          xs={3}
          className="mb-3"
          style={{
            borderRight: "3px solid rgba(0,0,0,0.1)",
            textAlign: "right",
          }}
        >
          <div
            className="font-open-sans"
            style={{
              position: "sticky",
              top: "15px",
            }}
          >
            <span className="w-auto mx-auto display-6">{props.year}</span>
          </div>
        </Col>
        <Col xs={9}>
          <ul>
            {props.contents.map((elem) => (
              <li key={elem.id}>
                <AwardBox bgColor={props.bgColor} {...elem} />
              </li>
            ))}
          </ul>
        </Col>
      </Row>
    </div>
  );
};

export default AwardsList;
